import { ReportConfiguration, ReportPageSize } from '../../../types/Report'

export enum ReportField {
  SectionIntroduction = 'section-intro',
  DividerPage = 'divider-page',
  CommitteeSummary = 'committee-summary',
}

// Reports
export const GenericReportIndividualId = 'none'

export enum ReportDocumentType {
  Collective = 'Collective',
  Individual = 'Individual',
  Generic = 'Generic',
}

export const DefaultReportConfig: ReportConfiguration = {
  showDiversity: false,
  showTenure: false,
  pageSize: ReportPageSize.A4,
  systemAverageTitle: 'Better Boards',
  pages: {
    overallEffectiveness: {}
  },
  appendix: {
    knowhowAreas: true,
    roles: true
  }
}
